/**
 * IMPORTS
 */

import { useEffect } from "react";

import { useQuery } from "@tanstack/react-query";

import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

import { USER_QUERY_STALE_TIME } from "@/common/const/query-cache";
import { handleBuscarDadosUsuario } from "@/domain/use-cases/auth/auth";

export type IDadosUsuario = {
  id: number;
  nome: string;
  email: string;
  remessas_em_andamento: number;
  total_remessas_produzidas: number;
  features: string[];
};

export interface IDadosUsuarioResponse {
  code: number;
  message: string;
  data: IDadosUsuario;
}

/**
 * Mantém as features do usuário sincronizadas com `users/dados`.
 * As features já chegam no login; este hook apenas as atualiza depois.
 */
function useSincronizarDadosUsuario() {
  const { token: accessToken, isAuthenticated, setFeatures } = useStoreZustandUserAuth();

  const { data: dadosUsuarioResponse } = useQuery<IDadosUsuarioResponse>({
    queryKey: ["dados-usuario", accessToken],
    enabled: isAuthenticated && !!accessToken,
    queryFn: async () => {
      const response = await handleBuscarDadosUsuario(accessToken!);

      return response;
    },
    staleTime: USER_QUERY_STALE_TIME,
    refetchOnWindowFocus: true,
  });

  const features = dadosUsuarioResponse?.data?.features;

  useEffect(() => {
    if (Array.isArray(features)) setFeatures(features);
  }, [features, setFeatures]);
}

/**
 * EXPORTS
 */
export { useSincronizarDadosUsuario };
